

const setLoginInformation = (context, settings) => {
  context.commit('SET_LOGIN_INFORMATION', settings);
};

const setPurchaseType = (context, type) => {
  if (type) {
    context.commit('SET_PURCHASE_TYPE', type);
  } else {
    context.commit('UNSET_PURCHASE_TYPE');
  }
};

export default {
  setLoginInformation,
  setPurchaseType,
};
